export const enum LinkAnchors {
    HOME = "/",
    ABOUT = "/about/",
    FINDER = "/finder/",
    CONTACT = "/contact/",
    LEGAL = "/legal/",
    PRODUCTS = "/beer/",
    PROMOTIONS = "/promotions/",
    VAULT = "/vault/",
    BREWHOUSE = "/brewhouse/",
    NEWSLETTER = "/newsletter/",
    NUTRITIONAL = "/pdf/Genesee_Serving_Facts_09-14-21.pdf",
    DISTINCTION = "/beers-of-distinction/",
}

export function ProductsLink(slug?: string | null): string {
    return !!slug ? `${LinkAnchors.PRODUCTS}${slug}/` : LinkAnchors.PRODUCTS;
}

export function PromoLink(slug?: string | null): string {
    return !!slug ? `${LinkAnchors.PROMOTIONS}${slug}/` : LinkAnchors.PROMOTIONS;
}

export function FinderLink(product?: string | null): string {
    if (!product) return LinkAnchors.FINDER;
    const searchParams = new URLSearchParams({product: encodeURIComponent(product)}).toString();
    return `${LinkAnchors.FINDER}?${searchParams}`;
}